<template>
  <div class="step-item last-step" :class="{ 'step-item--open': step3Open }" v-if="showGreetingCardExtra">
    <div class="step-header" @click="step3Open = !step3Open">
      <div class="step-header__title">
        <div class="step-header__icon">
          <svg width="45" height="45" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <circle cx="50" cy="22" r="20" />
            <circle cx="74.25" cy="36" r="20" />
            <circle cx="74.25" cy="64" r="20" />
            <circle cx="50" cy="78" r="20" />
            <circle cx="25.75" cy="64" r="20" />
            <circle cx="25.75" cy="36" r="20" />
            <circle cx="50" cy="50" r="20" />
            <circle cx="50" cy="50" r="8" fill="#F5F5F5" />
          </svg>
        </div>
        <h2>BUY A GIFT CARD</h2>
      </div>
      <div class="step-header__toggle">
        <svg width="20" height="11" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L7 7L13 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
    <transition name="collapse">
      <div v-show="step3Open" class="step-body-v3">
        <ProductGreetingCardExtraV2
          v-for="(greetingCardExtra, i) in greetingCardExtras"
          :key="i"
          :title="greetingCardExtra.title"
          :handle="greetingCardExtra.greetingCardHandle"
          :multiple-selection="true"
          :dynamic-price="greetingCardExtra.dynamicPrice"
          :show-no-option="true"
          :show-upsell-table="i === greetingCardExtras.length - 1"
          @greeting-card-selected="getProductGrettingCardSelected"
        />
      </div>
    </transition>
  </div>
</template>

<script lang="ts" setup>
import useProductStore from '@/store/product'
import useSettingStore from '@/store/setting'
import { onMounted, watch, computed, ref } from 'vue'
import { isProductHasTags } from '@/utils/product'
import {
  EVENT_UPDATE_GREETING_CARD_EXTRA,
  EVENT_UPDATE_GIFT_BOX_EXTRA,
  HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
} from '@/utils'
import EventBus from '@/services/eventbus'
import ProductGreetingCardExtraV2 from './ProductGreetingCardExtraV2.vue'

const productStore = useProductStore()
const settingStore = useSettingStore()
const EVENT_OPEN_STEP_3 = 'event-open-step-3'

const productGreetingCardExtras = ref<any[]>([])
const step3Open = ref(false)
const buyGiftBox = ref(false)

const greetingCardExtras = computed(() => {
  if (!settingStore.baseProductPage?.upsellGreetingCard?.length) {
    return []
  }
  return settingStore.baseProductPage?.upsellGreetingCard.filter((item: any) =>
    isProductHasTags(productStore.product, [item?.tag || ''])
  )
})

const showGreetingCardExtra = computed(() => {
  return greetingCardExtras.value?.length > 0
})

onMounted(() => {
  watch(
    () => productGreetingCardExtras.value,
    (val) => {
      const lineItems = val.map((item: any) => ({
        merchandiseId: item.merchandiseId,
        quantity: item.quantity || 1,
        attributes: item.attributes || [],
      }))
      EventBus.trigger(EVENT_UPDATE_GREETING_CARD_EXTRA, lineItems)
    },
    { deep: true }
  )

  watch(() => buyGiftBox.value, (val) => {
    EventBus.trigger(EVENT_UPDATE_GIFT_BOX_EXTRA, val ? { checked: true } : null)
  })

  EventBus.on(EVENT_OPEN_STEP_3, () => {
    step3Open.value = true
  })
})

function getProductGrettingCardSelected(data: any) {
  productGreetingCardExtras.value = productGreetingCardExtras.value.filter(
    (item: any) => item.productHandle !== data.productHandle
  )

  if (data.greetingCardVariantArrSelected?.length) {
    const selected = data.greetingCardVariantArrSelected.map((variant: any) => ({
      productHandle: data.productHandle,
      merchandiseId: variant.id,
      quantity: 1,
      attributes: [
        {
          key: HANDLE_PRODUCT_UPSELL_WITH_GREETING_CARD,
          value: productStore.product?.handle,
        },
        { key: '_Pack 1', value: '3.99' },
        { key: '_Pack 2 - 25% OFF', value: '5.99' },
        { key: '_Pack 3 - 33% OFF', value: '7.99' },
        { key: '_Pack 5 - 50% OFF', value: '9.99' },
        { key: '_product-pack', value: 'true' },
      ],
    }))
    productGreetingCardExtras.value.push(...selected)
  }
}
</script>

<style lang="scss" scoped>
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease-in-out !important;
  max-height: 1000px !important;
  overflow: hidden !important;
  opacity: 1 !important;
}

.collapse-enter-from,
.collapse-leave-to {
  max-height: 0 !important;
  opacity: 0 !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
